/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Full_Legal_Name_Must_Match_YoInputs */

const en_full_legal_name_must_match_yo = /** @type {(inputs: Full_Legal_Name_Must_Match_YoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full legal name (must match your bank account)`)
};

const es_full_legal_name_must_match_yo = /** @type {(inputs: Full_Legal_Name_Must_Match_YoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre legal completo (debe coincidir con tu cuenta bancaria)`)
};

const fr_full_legal_name_must_match_yo = /** @type {(inputs: Full_Legal_Name_Must_Match_YoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom légal complet (doit correspondre à votre compte bancaire)`)
};

const de_full_legal_name_must_match_yo = /** @type {(inputs: Full_Legal_Name_Must_Match_YoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vollständiger rechtlicher Name (muss mit deinem Bankkonto übereinstimmen)`)
};

const ja_full_legal_name_must_match_yo = /** @type {(inputs: Full_Legal_Name_Must_Match_YoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`法的な氏名 (銀行口座名義と一致している必要があります)`)
};

const zh_full_legal_name_must_match_yo = /** @type {(inputs: Full_Legal_Name_Must_Match_YoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`法定全名 (必须与您的银行账户一致)`)
};

const ar_full_legal_name_must_match_yo = /** @type {(inputs: Full_Legal_Name_Must_Match_YoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الاسم القانوني الكامل (يجب أن يطابق حسابك المصرفي)`)
};

const id_full_legal_name_must_match_yo = /** @type {(inputs: Full_Legal_Name_Must_Match_YoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nama lengkap resmi (harus cocok dengan rekening bank Anda)`)
};

const it_full_legal_name_must_match_yo = /** @type {(inputs: Full_Legal_Name_Must_Match_YoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome legale completo (deve corrispondere al tuo conto bancario)`)
};

const ru_full_legal_name_must_match_yo = /** @type {(inputs: Full_Legal_Name_Must_Match_YoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Полное юридическое имя (должно совпадать с именем в банковском счете)`)
};

const pt_full_legal_name_must_match_yo = /** @type {(inputs: Full_Legal_Name_Must_Match_YoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome completo legal (deve corresponder à sua conta bancária)`)
};

const ko_full_legal_name_must_match_yo = /** @type {(inputs: Full_Legal_Name_Must_Match_YoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`법적 성명 (은행 계좌 명의와 일치해야 함)`)
};

/**
* | output |
* | --- |
* | "Full legal name (must match your bank account)" |
*
* @param {Full_Legal_Name_Must_Match_YoInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const full_legal_name_must_match_yo = /** @type {((inputs?: Full_Legal_Name_Must_Match_YoInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Full_Legal_Name_Must_Match_YoInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_full_legal_name_must_match_yo(inputs)
	if (locale === "es") return es_full_legal_name_must_match_yo(inputs)
	if (locale === "fr") return fr_full_legal_name_must_match_yo(inputs)
	if (locale === "de") return de_full_legal_name_must_match_yo(inputs)
	if (locale === "ja") return ja_full_legal_name_must_match_yo(inputs)
	if (locale === "zh") return zh_full_legal_name_must_match_yo(inputs)
	if (locale === "ar") return ar_full_legal_name_must_match_yo(inputs)
	if (locale === "id") return id_full_legal_name_must_match_yo(inputs)
	if (locale === "it") return it_full_legal_name_must_match_yo(inputs)
	if (locale === "ru") return ru_full_legal_name_must_match_yo(inputs)
	if (locale === "pt") return pt_full_legal_name_must_match_yo(inputs)
	return ko_full_legal_name_must_match_yo(inputs)
});